<!-- 編集フォーム -->
@if (isEditMode) {
  @if (activeDocumentTab === 'plan') {
    <app-my-event-edit-form
      [eventId]="eventId"
      [documentType]="activeDocumentTab"
      (cancelled)="onCancelEdit()"
    ></app-my-event-edit-form>
  } @else {
    <app-my-report-edit-form
      [eventId]="eventId"
      (cancelled)="onCancelEdit()"
    ></app-my-report-edit-form>
  }
}

<!-- スピナー -->
<!-- @if (!isEditMode && showSpinner) {
  <div class="spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}
-->

<!-- メインコンテンツ -->
@if (!isEditMode && eventDetail) {
  <div class="detail-container">
    <!-- 左サイドメニュー -->
    <div class="side-menu">
      <!-- 帳票タブ -->
      <div
        class="document-tab"
        [class.active]="activeDocumentTab === 'plan'"
        (click)="onDocumentTabChange('plan')"
      >
        企画書
      </div>

      @if (canViewReportTab) {
        <div
          class="document-tab"
          [class.active]="activeDocumentTab === 'report'"
          (click)="onDocumentTabChange('report')"
        >
          報告書
        </div>
      }
      <button
        mat-raised-button
        class="close-btn"
        (click)="onClose()">一覧に戻る</button>

      <!-- 削除ボタン -->
      @if (
        canDelete &&
        !(
          eventDetail.documentType === 'report' &&
          activeDocumentTab === 'plan'
        )
      ) {
        <button
          mat-raised-button
          class="delete-btn"
          (click)="onDelete()"
        >
          削除
        </button>
      }
    </div>

    <!-- メインエリア -->
    <div class="main-area" #mainArea [style.min-height.px]="mainAreaMinHeight">

      @if (showSpinner) {
        <div class="spinner">
          <mat-spinner diameter="60"></mat-spinner>
        </div>
      } @else {
        <!-- ヘッダー -->
        <div class="detail-header">
          <h2 class="document-type-title">
            {{ activeDocumentTab === 'plan' ? '企画書' : '報告書' }}
          </h2>
          <span class="status-badge" [class]="'status-' + eventDetail.status">
            {{
              eventDetail.documentType === 'report'
                && activeDocumentTab === 'plan'
                  ? getStatusLabel('completed')
                  : getStatusLabel(eventDetail.status)
            }}
          </span>
        </div>

        <!-- プレビュータブ -->
        <div class="preview-section">
          <div class="preview-tabs-wrapper">
            <div class="preview-tabs">
              <button
                class="preview-tab"
                [class.active]="activePreviewTab === 'self'"
                (click)="onPreviewTabChange('self')"
              >
                自組織プレビュー
              </button>
              <button
                class="preview-tab"
                [class.active]="activePreviewTab === 'other'"
                (click)="onPreviewTabChange('other')"
              >
                他組織プレビュー
              </button>
            </div>

            <!-- 編集ボタン -->
            @if (canEdit) {
              <button
                mat-raised-button
                class="edit-btn"
                (click)="onEdit()"
              >
                編集
              </button>
            }
          </div>

          <!-- プレビューコンテンツ -->
          <div class="preview-content" #previewContent [style.min-height.px]="previewMinHeight">
            @if (activePreviewTab === 'self') {
              @if (activeDocumentTab === 'plan') {
                @if (!planPreviewReady) {
                  <div class="spinner">
                    <mat-spinner diameter="60"></mat-spinner>
                  </div>
                } @else {
                  <div class="plan-preview-wrap">
                    <div class="form-table">

                      <div class="form-row preview-row">
                          <div class="form-label">タイトル</div>
                            <div class="form-field title">
                              @if (planForm.title) {
                                  {{ planForm.title }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                      </div>

                      <div class="form-row preview-row">
                        <div class="form-label">カテゴリー</div>
                          <div class="form-field">
                            @if (categoryMajorName) {
                              <div class="category-row large">
                                <span class="sub-label">大分類</span>
                                <span class="category-major-text">{{ categoryMajorName }}</span>
                              </div>
                            }
                            @if (!isInitialState) {
                              @if (getPlanMasterNameArray(planForm.categorySub, 'category_sub'); as subs) {
                                <div class="category-row">
                                  <span class="sub-label">中分類</span>
                                @if (subs.length > 0) {
                                        <div class="checkbox-grid">
                                            @for (sub of subs; track sub; let i = $index) {
                                              <label class="priority-checkbox">
                                                <span class="priority-num">{{ i + 1 }}</span> {{ sub }}
                                              </label>
                                            }
                                        </div>
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                              }
                            }
                          </div>
                      </div>
                      @if (!isInitialState) {
                        <div class="form-row preview-row one-row">
                          <div class="form-label">公開範囲</div>
                          <div class="form-field">
                            @if (planForm.publicScope) {
                              {{ getPlanMasterName('public_scope', planForm.publicScope) }}
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                        </div>
                        @if (planShowIssueSection) {
                          <div class="form-row preview-row">
                            <div class="form-label">改善したい指標</div>
                            <div class="form-field">
                              <div class="category-row">
                                <span class="sub-label">状態の変化</span>
                                @if (getPlanMasterNameArray(planForm.improvementIndicatorState, 'improvement_indicator_state'); as improvement_indicator_states) {
                                  @if (improvement_indicator_states.length > 0) {
                                          <div class="checkbox-grid">
                                              @for (improvement_indicator_state of improvement_indicator_states; track improvement_indicator_state; let i = $index) {
                                                <label class="priority-checkbox">
                                                  <span class="priority-num">{{ i + 1 }}</span> {{ improvement_indicator_state }}
                                                </label>
                                              }
                                          </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                            </div>
                            @if (planShowTargetOrg) {
                              <div class="category-row">
                                <span class="sub-label">企画の成果</span>
                                @if (planForm.improvementIndicatorOutcome) {
                                 {{ getPlanMasterName('improvement_indicator_outcome', planForm.improvementIndicatorOutcome) }}
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            }
                          </div>
                          </div>

                          <div class="form-row preview-row">
                            <div class="form-label">目的</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (getPlanMasterNameArray(planForm.purpose, 'purpose'); as purposes) {
                                  @if (purposes.length > 0) {
                                          <div class="checkbox-grid">
                                              @for (purpose of purposes; track purpose; let i = $index) {
                                                <label class="priority-checkbox">
                                                  <span class="priority-num">{{ i + 1 }}</span> {{ purpose }}
                                                </label>
                                              }
                                          </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }

                        <div class="form-row preview-row">
                          @if (planForm.summary) {
                            <div class="form-label text">企画の概要</div>
                            <div class="form-field text">
                              <div class="text-content">{{ planForm.summary }}</div>
                            </div>
                          } @else {
                            <div class="form-label">企画の概要</div>
                            <div class="form-field">
                              <span class="unregistered">未登録</span>
                            </div>
                          }
                        </div>

                        @if (planShowSocialTheme) {
                          <div class="form-row preview-row">
                            <div class="form-label">社会テーマ</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (getPlanMasterNameArray(planForm.socialTheme, 'social_theme'); as socials) {
                                  @if (socials.length > 0) {
                                          <div class="checkbox-grid">
                                              @for (social of socials; track social; let i = $index) {
                                                <label class="priority-checkbox">
                                                  <span class="priority-num">{{ i + 1 }}</span> {{ social }}
                                                </label>
                                              }
                                          </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }

                        <div class="form-row preview-row">
                          <div class="form-label">開催者所属</div>
                          <div class="form-field">
                            <div class="category-row">
                              <div class="checkbox-grid">
                                <span class="sub-label">組織</span>
                                @if (planForm.organizerUnit) {
                                  {{ getPlanMasterName('organizer_org_unit', planForm.organizerUnit) }}
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            </div>
                            <div class="category-row">
                              <span class="sub-label">詳細</span>
                              @if (planForm.organizerOrgDetailText) {
                                <div class="org-detail-lines">
                                  @for (line of planForm.organizerOrgDetailText.split('\n'); track $index) {
                                    <div class="org-detail-line-wrapper">
                                      <div class="dot">・</div>
                                      <div class="org-detail-line">{{ line }}</div>
                                    </div>
                                  }
                                </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        </div>

                        @if (planShowTargetOrg) {
                          <div class="form-row preview-row">
                            <div class="form-label">対象組織</div>
                            <div class="form-field">
                              <div class="category-row">
                                <div class="checkbox-grid">
                                  <span class="sub-label">単位</span>
                                    @if (planForm.targetUnit) {
                                     {{ getPlanMasterName('organizer_org_unit', planForm.targetUnit) }}
                                    } @else {
                                      <span class="unregistered">未登録</span>
                                    }
                                </div>
                              </div>
                              <div class="category-row">
                                <span class="sub-label">詳細</span>
                                @if (planForm.targetOrgDetailText) {
                                  <div class="org-detail-lines">
                                    @for (line of planForm.targetOrgDetailText.split('\n'); track $index) {
                                      <div class="org-detail-line-wrapper">
                                        <div class="dot">・</div>
                                        <div class="org-detail-line">{{ line }}</div>
                                      </div>
                                    }
                                  </div>
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            </div>
                          </div>
                        }

                        @if (planShowTargetOrg) {
                          <div class="form-row preview-row">
                            <div class="form-label">対象/参加者</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (planForm.participantCategory) {
                                  {{ getPlanMasterName('participant_category', planForm.participantCategory) }}
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                              @if (planForm.participantCategory !== 199) {
                                <div class="category-row detail-row">

                                  <span class="sub-label">詳細</span>

                                  @if (getPlanParticipantDetailDisplay(); as detail) {
                                    <div class="detail-values">
                                      @for (item of detail.split('、'); track item; let last = $last) {
                                        <span class="detail-chip">
                                          {{ item }}@if (!last) {、}
                                        </span>
                                      }
                                    </div>

                                  } @else {
                                    <span class="unregistered">未登録</span>

                                  }

                                </div>
                              }
                            </div>
                          </div>

                          @if (getPlanAttrGenerationDisplay() || getPlanAttrGenderDisplay()) {
                            <div class="form-row preview-row">
                              <div class="form-label">└ 属性</div>

                              <div class="form-field">

                                @if (getPlanAttrGenerationDisplay(); as gen) {
                                  <div class="category-row">
                                    <div class="checkbox-grid">
                                      <span class="sub-label">年代</span>
                                      {{ gen }}
                                    </div>
                                  </div>
                                }

                                @if (getPlanAttrGenderDisplay(); as gender) {
                                  <div class="category-row">
                                    <div class="checkbox-grid">
                                      <span class="sub-label">性別</span>
                                      {{ gender }}
                                    </div>
                                  </div>
                                }

                              </div>
                            </div>
                          }
                        }

                        @if (
                          planshowCompanyOtherCollaboration &&
                          (
                            planCategoryId !== 10 ||
                            getPlanCompanyOtherCollaborationLabel()
                          )
                        ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">他労組共同開催</div>
                            <div class="form-field">
                              @if (getPlanCompanyOtherCollaborationLabel()) {
                                {{ getPlanCompanyOtherCollaborationLabel() }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (
                          planShowCompanyCollaboration &&
                          (
                            planCategoryId !== 10 ||
                            getPlanCompanyCollaborationLabel()
                          )
                          ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">会社協働・協賛</div>
                            <div class="form-field">
                              @if (getPlanCompanyCollaborationLabel()) {
                                {{ getPlanCompanyCollaborationLabel() }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }


                        <div class="form-row preview-row one-row">
                          <div class="form-label">実施方法</div>
                          <div class="form-field">
                            @if (planForm.implementationMethod) {
                              {{ getPlanMasterName('implementation_method', planForm.implementationMethod)}}
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                        </div>

                        @if (
                          planShowHoldingMethod &&
                          (
                            planCategoryId !== 10 ||
                            planForm.holdingMethod
                          )
                          ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">開催方法</div>
                            <div class="form-field">
                              @if (planForm.holdingMethod) {
                                {{ getPlanMasterName('holding_method', planForm.holdingMethod) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (
                          planShowEducationFormat &&
                        (
                          planCategoryId !== 10 ||
                          getPlanMultiDisplay(planForm.educationFormat, 'education_format')
                        )
                        ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">教育形式</div>
                            <div class="form-field">
                              @if (getPlanMultiDisplay(planForm.educationFormat, 'education_format')) {
                                {{ getPlanMultiDisplay(planForm.educationFormat, 'education_format') }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowSurveyMethod &&
                          (
                            planCategoryId !== 10 ||
                            planForm.surveyMethod
                          )
                          ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">調査方法</div>
                            <div class="form-field">
                              @if (planForm.surveyMethod) {
                                  {{ getPlanMasterName('survey_method', planForm.surveyMethod) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowAnnouncementMethod) {
                          <div class="form-row preview-row">
                            <div class="form-label">案内方法</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (getPlanMasterNameArray(planForm.announcementMethod, 'announcement_method'); as announces) {
                                  @if (announces.length > 0) {
                                          <div class="checkbox-grid">
                                              @for (announce of announces; track announce; let i = $index) {
                                                <label class="priority-checkbox">
                                                  <span class="priority-num">{{ i + 1 }}</span> {{ announce }}
                                                </label>
                                              }
                                          </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }

                        @if (planShowRecruitmentMethod) {
                          <div class="form-row preview-row">
                            <div class="form-label">応募方法</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (getPlanMasterNameArray(planForm.recruitmentMethod, 'recruitment_method'); as recruits) {
                                  @if (recruits.length > 0) {
                                    <div class="checkbox-grid">
                                        @for (recruit of recruits; track recruit; let i = $index) {
                                          <label class="priority-checkbox">
                                            <span class="priority-num">{{ i + 1 }}</span> {{ recruit }}
                                          </label>
                                        }
                                    </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }

                        @if (planShowVenue) {
                          <div class="form-row preview-row">
                            <div class="form-label">会場</div>
                            <div class="form-field">{{ getPlanMasterName('venue', planForm.venue) }}</div>
                          </div>
                        }

                        <div class="form-row preview-row">
                          <div class="form-label">
                            開催日数
                          </div>

                          <div class="form-field">
                            @for (row of planScheduleRows; track row.index) {
                              <div class="category-row">

                                @if (getPlanScheduleDisplay(row.index); as schedule) {
                                <span
                                  class="schedule-label"
                                  [class.period]="planForm.numberOfDays === 'period'"
                                >
                                  {{ row.label }}
                                </span>

                                  @if (schedule.date && schedule.start && schedule.end) {
                                    <span class="date-label">
                                      {{ schedule.date }}
                                    </span>

                                    <span class="time-group">
                                      <span class="time-label">開始</span>
                                      <span>{{ schedule.start }}</span>
                                    </span>

                                    <span class="time-group">
                                      <span class="time-label">終了</span>
                                      @if (schedule.end  && schedule.start <= schedule.end) {
                                        <span>{{ schedule.end }}</span>
                                      } @else {
                                        <span class="unregistered">未登録</span>
                                      }
                                    </span>

                                    <span class="time-group">
                                      <span class="time-label">実施時間</span>

                                      @if (schedule.duration) {
                                        <span>{{ schedule.duration }}</span>
                                      }
                                    </span>

                                  } @else {
                                    <span class="unregistered">未登録</span>

                                  }

                                }

                              </div>
                            }
                          </div>
                        </div>


                        @if (planShowEstimatedParticipants) {
                          <div class="form-row preview-row">
                            <div class="form-label">想定参加人数</div>
                            <div class="form-field">
                              @if (planForm.estimatedParticipants !== null && planForm.estimatedParticipants !== undefined) {
                                <div class="number-with-unit">
                                  {{ planForm.estimatedParticipants }}
                                  <span class="unit">人</span>
                                  @if (coverageRate) {
                                    <span class="calc-result">カバー率　{{ coverageRate }}</span>
                                  }
                                </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowCostSection && ( planForm.categoryId != 10 || planForm.estimatedTotalCost )) {
                          <div class="form-row preview-row">
                            <div class="form-label">想定費用総額</div>
                            <div class="form-field">
                              @if (planForm.estimatedTotalCost !== null && planForm.estimatedTotalCost !== undefined) {
                                <div class="number-with-unit">
                                  {{ formatPlanCurrency(planForm.estimatedTotalCost) }}
                                  <span class="unit">円</span>
                                  @if (costPerPerson) {
                                    <span class="calc-result">一人当たり費用　{{ costPerPerson }}</span>
                                  }
                                </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowSubsidyAndVendors && ( planForm.categoryId !== 10 || planForm.subsidyAmount )) {
                          <div class="form-row preview-row">
                            <div class="form-label">補助金額</div>
                            <div class="form-field">
                              @if (planForm.subsidyAmount !== null && planForm.subsidyAmount !== undefined) {
                                <div class="number-with-unit">
                                  {{ formatPlanCurrency(planForm.subsidyAmount) }}
                                  <span class="unit">円</span>
                                  @if (subsidyRate) {
                                    <span class="calc-result">補助率　{{ subsidyRate }}</span>
                                  }
                                </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowSubsidyAndVendors && hasVisibleVendors) {
                          @for (vendor of planForm.vendors; track $index; let i = $index) {
                          <div class="vendor-section" [class.has-divider]="i > 0" [class.is-last]="i === planForm.vendors.length - 1">
                            <div class="form-row preview-row">

                              <div class="form-label" [class.vendor]="true">
                                外部業者
                              </div>

                              <div class="form-field vendor">
                                <div class="vendor-fields">

                                  @if (vendor.companyName) {
                                    <div class="vendor-row">
                                      <span class="sub-label">会社/組織名</span>
                                      <div class="field-with-count">
                                        {{ vendor.companyName }}
                                      </div>
                                    </div>
                                  }

                                  @if (vendor.contactPerson) {
                                    <div class="vendor-row">
                                      <span class="sub-label">担当者</span>
                                      <div class="field-with-count">
                                        {{ vendor.contactPerson }}
                                      </div>
                                    </div>
                                  }

                                  @if (vendor.contactInfo) {
                                    <div class="vendor-row">
                                      <span class="sub-label">連絡先</span>
                                      <div class="field-with-count">
                                        {{ vendor.contactInfo }}
                                      </div>
                                    </div>
                                  }

                                  @if (vendor.workSummary) {
                                    <div class="vendor-row">
                                      <span class="sub-label">担当概要</span>
                                      <div class="field-with-count text">
                                        <div class="text-content">{{ vendor.workSummary }}</div>
                                      </div>
                                    </div>
                                  }

                                  @if (vendor.workDurationMinutes != null) {
                                    <div class="vendor-row">
                                      <span class="sub-label">担当時間</span>
                                      <div class="field-with-count">
                                        {{ formatPlanDuration(vendor.workDurationMinutes) }}
                                      </div>
                                    </div>
                                  }

                                  @if (vendor.specificCost != null) {
                                    <div class="vendor-row">
                                      <span class="sub-label">金額</span>
                                      <div class="number-with-unit vendor-margintop">
                                        {{ formatPlanCurrency(vendor.specificCost) }}
                                        <span class="unit">円</span>

                                        @if (getVendorCostLabel(vendor.specificCost); as label) {
                                          <span class="calc-result">
                                            概算費用　{{ label }}
                                          </span>
                                        }
                                      </div>
                                    </div>
                                  }

                                </div>
                              </div>
                            </div>
                          </div>
                          }
                        }

                        @if (planAttachments[1].length > 0) {
                          <div class="form-row preview-row">
                            <div class="form-label">実施時使用資料/教材</div>
                            <div class="form-field">
                              <div class="attachment-list">
                                @for (att of planAttachments[1]; track $index) {
                                  <div class="attachment-item">
                                    <div
                                      class="attachment-name"
                                      [class.attachment-link]="att.downloadUrl"
                                      (click)="onDownloadPlanAttachment(att)"
                                    >{{ att.fileName }}</div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        }

                        @if (planForm.implementationChallenges) {
                          <div class="form-row preview-row">
                            <div class="form-label text">実施する際の課題</div>
                            <div class="form-field text">
                              <div class="text-content">{{ planForm.implementationChallenges }}</div>
                            </div>
                          </div>
                        }

                        @if (planForm.countermeasures) {
                          <div class="form-row preview-row">
                            <div class="form-label text">対策</div>
                            <div class="form-field text">
                              <div class="text-content">{{ planForm.countermeasures }}</div>
                            </div>
                          </div>
                        }

                        @if (planShowWorkplaceSection) {
                          <div class="form-row preview-row">
                              @if (planForm.workplaceExpectedIssues) {
                                <div class="form-label text">該当職場の想定議題</div>
                                <div class="form-field text">
                                  <div class="text-content">{{ planForm.workplaceExpectedIssues }}</div>
                                </div>
                              } @else {
                                <div class="form-label">該当職場の想定議題</div>
                                <div class="form-field">
                                  <span class="unregistered">未登録</span>
                                </div>
                              }
                          </div>
                        }

                        @if (planShowWorkplaceSection) {
                          <div class="form-row preview-row">
                              @if (planForm.keyHearingItems) {
                                <div class="form-label text">重点ヒアリング項目</div>
                                <div class="form-field text">
                                  <div class="text-content">{{ planForm.keyHearingItems }}</div>
                                </div>
                              } @else {
                                <div class="form-label">重点ヒアリング項目</div>
                                <div class="form-field">
                                  <span class="unregistered">未登録</span>
                                </div>
                              }
                          </div>
                        }

                        @if (planShowEffectiveness &&
                          (
                            planCategoryId !== 10 ||
                            planForm.effectivenessMeasurement
                          )
                          ) {
                          <div class="form-row preview-row">
                            <div class="form-label">効果測定</div>
                            <div class="form-field">
                              @if (planForm.effectivenessMeasurement) {
                                {{ getPlanMasterName('effectiveness_measurement', planForm.effectivenessMeasurement) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowMeetingSection) {
                          <div class="form-row preview-row">
                            <div class="form-label">会議体・対応形式</div>
                            <div class="form-field">
                              @if (getPlanMultiDisplay(planForm.meetingFormats, 'meeting_format')) {
                                {{ getPlanMultiDisplay(planForm.meetingFormats, 'meeting_format') }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                          <div class="form-row preview-row">
                            <div class="form-label">主な相手区分</div>
                            <div class="form-field">
                              @if (getPlanMultiDisplay(planForm.counterpartTypes, 'counterpart_type')) {
                                {{ getPlanMultiDisplay(planForm.counterpartTypes, 'counterpart_type') }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planAttachments[2].length > 0) {
                          <div class="form-row preview-row">
                            <div class="form-label">企画/検討資料など</div>
                            <div class="form-field">
                              <div class="attachment-list">
                                @for (att of planAttachments[2]; track $index) {
                                  <div class="attachment-item">
                                    <div
                                      class="attachment-name"
                                      [class.attachment-link]="att.downloadUrl"
                                      (click)="onDownloadPlanAttachment(att)"
                                    >{{ att.fileName }}</div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        }

                        @if (planForm.memo) {
                          <div class="form-row preview-row">
                            <div class="form-label text">メモ</div>
                            <div class="form-field text">
                              <div class="text-content">{{ planForm.memo }}</div>
                            </div>
                          </div>
                        }
                      }

                    </div>
                  </div>
                }
              } @else if (activeDocumentTab === 'report') {
                @if (!planPreviewReady) {
                  <div class="spinner">
                    <mat-spinner diameter="60"></mat-spinner>
                  </div>
                } @else {
                  <div class="plan-preview-wrap">
                    <div class="form-table">
                    <div class="form-row preview-row">
                      <div class="form-label">タイトル</div>
                        <div class="form-field title">
                          @if (planForm.title) {
                              {{ planForm.title }}
                          } @else {
                            <span class="unregistered">未登録</span>
                          }
                        </div>
                    </div>

                    <div class="form-row preview-row">
                      <div class="form-label">カテゴリー</div>
                        <div class="form-field">
                          @if (categoryMajorName) {
                            <div class="category-row large">
                              <span class="sub-label">大分類</span>
                              <span class="category-major-text">{{ categoryMajorName }}</span>
                            </div>
                          }
                            @if (getPlanMasterNameArray(planForm.categorySub, 'category_sub'); as subs) {
                              <div class="category-row">
                                <span class="sub-label">中分類</span>
                              @if (subs.length > 0) {
                                      <div class="checkbox-grid">
                                          @for (sub of subs; track sub; let i = $index) {
                                            <label class="priority-checkbox">
                                              <span class="priority-num">{{ i + 1 }}</span> {{ sub }}
                                            </label>
                                          }
                                      </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                            }
                        </div>
                    </div>
                    @if (!isInitialStateReport) {
                      <div class="form-row preview-row one-row">
                        <div class="form-label">実施状況</div>
                        <div class="form-field implementation">
                          @if (reportForm.implementationStatus) {
                            {{ getPlanMasterName('report_implementation_status', reportForm.implementationStatus)}}
                          } @else {
                            <span class="unregistered">未登録</span>
                          }
                        </div>
                      </div>

                      @if (!isLimitedDisplay) {
                        <div class="form-row preview-row one-row">
                          <div class="form-label">実施方法</div>
                          <div class="form-field">
                            @if (reportForm.implementationMethod) {
                              {{ getPlanMasterName('implementation_method', reportForm.implementationMethod)}}
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                        </div>
                      }

                      @if (showProblem) {
                        <div class="form-row preview-row">
                          <div class="form-label">問題の有無</div>
                          <div class="form-field comment">
                            @if (getReportHasProblemabel()) {
                              {{ getReportHasProblemabel() }}
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                            @if( reportForm.problemComment ){
                              <div class="text-content comment">{{ reportForm.problemComment }}</div>
                            }
                          </div>
                        </div>
                      }

                      @if (!isLimitedDisplay && showStakeholderAndChallenges) {
                        <div class="form-row preview-row">
                          @if (reportForm.stakeholderInfo) {
                            <div class="form-label text">関係者情報</div>
                            <div class="form-field text">
                              <div class="text-content">{{ reportForm.stakeholderInfo }}</div>
                            </div>
                          } @else {
                            <div class="form-label">関係者情報</div>
                            <div class="form-field">
                              <span class="unregistered">未登録</span>
                            </div>
                          }
                        </div>
                      }

                      <div class="form-row preview-row">
                        <div class="form-label">企画書からの変更点</div>
                        <div class="form-field comment">
                          @if (getReportHasChangeFromPlan()) {
                            {{ getReportHasChangeFromPlan() }}
                          } @else {
                            <span class="unregistered">未登録</span>
                          }
                          @if( reportForm.changeFromPlanComment ){
                            <div class="text-content comment">{{ reportForm.changeFromPlanComment }}</div>
                          }
                        </div>
                      </div>

                      @if (!isLimitedDisplay && showCost) {
                        @if (
                          reportForm.categoryId !== 10 ||
                          (reportForm.actualTotalCost !== null && reportForm.actualTotalCost !== undefined)
                        ) {
                          <div class="form-row preview-row">
                            <div class="form-label">実費費用総額</div>
                            <div class="form-field">
                              @if (reportForm.actualTotalCost !== null && reportForm.actualTotalCost !== undefined) {
                                <div class="number-with-unit">
                                  {{ formatPlanCurrency(reportForm.actualTotalCost) }}
                                  <span class="unit">円</span>
                                  @if (costDiff) {
                                    <span class="calc-result">想定費用との差額　{{ costDiff }}</span>
                                  }
                                </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }
                        @if(reportForm.costDiffReason){
                          <div class="form-row preview-row">
                            <div class="form-label text">差額発生理由など</div>
                            <div class="form-field text">
                              <div class="field-with-count">
                                <div class="text-content">{{ reportForm.costDiffReason }}</div>
                              </div>
                            </div>
                          </div>
                        }
                      }

                      @if (!isLimitedDisplay && showTotalParticipants) {
                        <div class="form-row preview-row one-row">
                          <div class="form-label">参加者</div>
                          <div class="form-field">
                            <div class="category-row">
                              <span class="time-group">
                                <span class="sub-label first-inline">総数</span>
                                <div class="number-with-unit">
                                  @if (reportForm.participantTotal !== null && reportForm.participantTotal !== undefined) {
                                    {{ reportForm.participantTotal }}
                                    <span class="unit">人</span>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                </div>
                              </span>
                              @if (showParticipantDetail) {
                                <span class="time-group">
                                  <span class="sub-label ml20">新規</span>
                                  <div class="number-with-unit">
                                    @if (reportForm.participantNew !== null && reportForm.participantNew !== undefined) {
                                      {{ reportForm.participantNew }}
                                      <span class="unit">人</span>
                                    } @else {
                                      <span class="unregistered">未登録</span>
                                    }
                                  </div>
                                </span>
                              }
                            </div>
                          </div>
                        </div>

                        @if (showParticipantDetail) {
                          @if (
                            reportForm.ageRatio?.unknown ||
                            reportForm.ageRatio?.under19 != null ||
                            reportForm.ageRatio?.age20s != null ||
                            reportForm.ageRatio?.age30s != null ||
                            reportForm.ageRatio?.age40s != null ||
                            reportForm.ageRatio?.age50s != null ||
                            reportForm.ageRatio?.over60 != null
                          ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">年代</div>
                            <div class="form-field">
                              <div class="category-row age">
                                @if(reportForm.ageRatio.unknown) {
                                  不明
                                } @else {
                                  @if( reportForm.ageRatio.under19 ){
                                    <span class="time-group">
                                      <span class="sub-label">19歳以下</span>
                                        {{ reportForm.ageRatio.under19 }}%
                                    </span>
                                  }
                                  @if( reportForm.ageRatio.age20s ){
                                    <span class="time-group">
                                      <span class="sub-label">20代</span>
                                        {{ reportForm.ageRatio.age20s }}%
                                    </span>
                                  }
                                  @if( reportForm.ageRatio.age30s ){
                                    <span class="time-group">
                                      <span class="sub-label">30代</span>
                                        {{ reportForm.ageRatio.age30s }}%
                                    </span>
                                  }
                                  @if( reportForm.ageRatio.age40s ){
                                    <span class="time-group">
                                      <span class="sub-label">40代</span>
                                        {{ reportForm.ageRatio.age40s }}%
                                    </span>
                                  }
                                  @if( reportForm.ageRatio.age50s ){
                                    <span class="time-group">
                                      <span class="sub-label">50代</span>
                                        {{ reportForm.ageRatio.age50s }}%
                                    </span>
                                  }
                                  @if( reportForm.ageRatio.over60 ){
                                    <span class="time-group">
                                      <span class="sub-label">60代以上</span>
                                        {{ reportForm.ageRatio.over60 }}%
                                    </span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                          }
                          <div class="form-row preview-row one-row">
                            <div class="form-label">女性比率</div>
                            <div class="form-field">
                              @if (reportForm.femaleRatio) {
                                {{ getPlanMasterName('report_female_ratio', reportForm.femaleRatio) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }
                      }

                      @if (!isLimitedDisplay && showOrgActivity) {
                        <div class="form-row preview-row">
                          @if (reportForm.implementationContent) {
                            <div class="form-label text">実施内容</div>
                            <div class="form-field text">
                              <div class="text-content">{{ reportForm.implementationContent }}</div>
                            </div>
                          } @else {
                            <div class="form-label">実施内容</div>
                            <div class="form-field">
                              <span class="unregistered">未登録</span>
                            </div>
                          }
                        </div>
                      }
                    }

                    @if (!isLimitedDisplay && showOutcomeResult) {
                      <div class="form-row preview-row one-row">
                        <div class="form-label">改善したい指標</div>
                        <div class="form-field">
                          <div class="category-row">
                            <span class="sub-label">企画の成果</span>
                            <div class="checkbox-grid">
                              @if (reportForm.improvementOutcomeText) {
                                {{ reportForm.improvementOutcomeText }}
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      @if (!isInitialStateReport) {
                        <div class="form-row preview-row">
                          @if (reportForm.implementationResult) {
                            <div class="form-label text">実施結果/成果</div>
                            <div class="form-field text">
                              <div class="text-content">{{ reportForm.implementationResult }}</div>
                            </div>
                          } @else {
                            <div class="form-label">実施結果/成果</div>
                            <div class="form-field">
                              <span class="unregistered">未登録</span>
                            </div>
                          }
                        </div>
                      }
                    }

                      @if (!isInitialStateReport) {
                        @if (!isLimitedDisplay && showStakeholderAndChallenges) {
                          @if( reportForm.challengesNotes ){
                            <div class="form-row preview-row">
                              <div class="form-label text">課題/気づき</div>
                              <div class="form-field text">
                                <div class="field-with-count">
                                  <div class="text-content">{{ reportForm.challengesNotes }}</div>
                                </div>
                              </div>
                            </div>
                          }
                        }

                        @if (!isLimitedDisplay && showNextImprovement) {
                          <div class="form-row preview-row">
                          @if (reportForm.nextImprovement) {
                            <div class="form-label text">次回改善点/引継事項</div>
                            <div class="form-field text">
                              <div class="field-with-count">
                                <div class="text-content">{{ reportForm.nextImprovement }}</div>
                              </div>
                            </div>
                          } @else {
                            <div class="form-label">次回改善点/引継事項</div>
                            <div class="form-field">
                              <span class="unregistered">未登録</span>
                            </div>
                          }
                          </div>
                        }

                        @if (!isLimitedDisplay && showLaborNegotiation) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">協議状況</div>
                            <div class="form-field negotiation">
                              @if (reportForm.negotiationStatus) {
                                {{ getPlanMasterName('report_negotiation_status', reportForm.negotiationStatus) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>


                          @if (showAgreementContent) {
                            <div class="form-row preview-row">
                              @if (reportForm.agreementContent) {
                                <div class="form-label text">合意内容</div>
                                <div class="form-field text">
                                  <div class="field-with-count">
                                    <div class="text-content">{{ reportForm.agreementContent }}</div>
                                  </div>
                                </div>
                              } @else {
                                <div class="form-label">合意内容</div>
                                <div class="form-field">
                                  <span class="unregistered">未登録</span>
                                </div>
                              }
                              </div>
                          }

                          <div class="form-row preview-row">
                            @if (reportForm.companyClaim) {
                              <div class="form-label text">会社側 主張/論理</div>
                              <div class="form-field text">
                                <div class="field-with-count">
                                  <div class="text-content">{{ reportForm.companyClaim }}</div>
                                </div>
                              </div>
                            } @else {
                              <div class="form-label">会社側 主張/論理</div>
                              <div class="form-field">
                                <span class="unregistered">未登録</span>
                              </div>
                            }
                          </div>

                          <div class="form-row preview-row">
                            @if (reportForm.unionClaim) {
                              <div class="form-label text">労組側 主張/論理</div>
                              <div class="form-field text">
                                <div class="field-with-count">
                                  <div class="text-content">{{ reportForm.unionClaim }}</div>
                                </div>
                              </div>
                            } @else {
                              <div class="form-label">労組側 主張/論理</div>
                              <div class="form-field">
                                <span class="unregistered">未登録</span>
                              </div>
                            }
                          </div>

                          @if (reportForm.unresolvedPoints) {
                            <div class="form-row preview-row">
                                <div class="form-label text">未整理論点/積み残し</div>
                                <div class="form-field text">
                                  <div class="field-with-count">
                                    <div class="text-content">{{ reportForm.unresolvedPoints }}</div>
                                  </div>
                                </div>
                            </div>
                          }
                        }
                      }


                      @if (!isLimitedDisplay && showImprovementResult) {
                        <div class="form-row preview-row one-row">
                          <div class="form-label">改善したい指標</div>
                          <div class="form-field">
                            <div class="category-row">
                              <span class="sub-label">状態の変化</span>
                              @if (getPlanMasterNameArray(_rawImprovementState, 'improvement_indicator_state'); as improvement_indicator_states) {
                                @if (improvement_indicator_states.length > 0) {
                                        <div class="checkbox-grid">
                                            @for (improvement_indicator_state of improvement_indicator_states; track improvement_indicator_state; let i = $index) {
                                              <label class="priority-checkbox">
                                                <span class="priority-num">{{ i + 1 }}</span> {{ improvement_indicator_state }}
                                              </label>
                                            }
                                        </div>
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              }
                            </div>
                          </div>
                        </div>
                        @if (!isInitialStateReport) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">改善指標に対する結果</div>
                            <div class="form-field negotiation">
                              @if (reportForm.improvementResultRating) {
                                {{ getPlanMasterName('report_improvement_result', reportForm.improvementResultRating) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                          @if (reportForm.improvementResultReason) {
                            <div class="form-row preview-row">
                              <div class="form-label text">判断理由/補足</div>
                              <div class="form-field text">
                                <div class="field-with-count">
                                  <div class="text-content">{{ reportForm.improvementResultReason }}</div>
                                </div>
                              </div>
                            </div>
                          }
                        }
                      }

                      @if (!isInitialStateReport) {
                        @if (!isLimitedDisplay && showEvaluation) {
                          @if (reportForm.reAttendanceRate != null) {
                            <div class="form-row preview-row">
                              <div class="form-label">再参加意向比率</div>
                              <div class="form-field">
                                <div class="number-with-unit">
                                  {{ reportForm.reAttendanceRate }}
                                  <span class="unit">%</span>
                                </div>
                              </div>
                            </div>
                          }

                          <div class="form-row preview-row">
                            <div class="form-label">参加者 評価</div>
                            <div class="form-field">
                              <div class="category-row">
                                <span class="time-group">
                                  @if (reportForm.participantEvalScore) {
                                    {{ getPlanMasterName('report_eval_score', reportForm.participantEvalScore) }}
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                </span>
                                @if (!isEvaluationUnrated) {
                                  <span class="time-group">
                                    <span class="sub-label ml20">評価収集数</span>
                                    @if (reportForm.evalCollectedCount !== null && reportForm.evalCollectedCount !== undefined) {
                                      {{ reportForm.evalCollectedCount }}
                                    } @else {
                                      <span class="unregistered">未登録</span>
                                    }
                                  </span>
                                  @if (c !== 6) {
                                    <span class="time-group">
                                      <span class="sub-label ml20">収集率</span>
                                      {{ collectionRate }}
                                    </span>
                                  }
                                }
                              </div>
                              <div class="category-row">
                                @if (isEvaluationUnrated) {
                                    <span class="sub-label">未評価理由</span>
                                      @if (reportForm.unevaluatedReason) {
                                        <div class="text-content unevaluatedReason">{{ reportForm.unevaluatedReason }}</div>
                                      } @else {
                                        <span class="unregistered">未登録</span>
                                      }
                                }
                              </div>
                            </div>
                          </div>

                          @if (
                            showParticipantDetail &&
                            (
                              reportForm.evaluationPart1.title ||
                              reportForm.evaluationPart1.score ||
                              reportForm.evaluationPart2.title ||
                              reportForm.evaluationPart2.score
                            )
                          ) {
                            <div class="form-row preview-row">
                              <div class="form-label">評価 内訳</div>
                              <div class="form-field eval">
                                <!-- イベント：1部 -->
                                @if (reportForm.evaluationPart1.title || reportForm.evaluationPart1.score) {
                                  <div class="eval-breakdown-block">
                                    <span class="breakdown-part-label">イベント：1部</span>
                                    @if (reportForm.evaluationPart1.title) {
                                      <div class="breakdown-row first">
                                        <span class="sub-label">タイトル</span>
                                        {{ reportForm.evaluationPart1.title }}
                                      </div>
                                    }

                                    @if (reportForm.evaluationPart1.score) {
                                      <div class="breakdown-row">
                                        <span class="sub-label">点数</span>
                                        {{ getPlanMasterName('report_event_score', reportForm.evaluationPart1.score) }}
                                      </div>
                                    }
                                  </div>
                                }

                                <!-- イベント：2部 -->
                                @if (reportForm.evaluationPart2.title || reportForm.evaluationPart2.score) {
                                  <div class="eval-breakdown-block">
                                    <span class="breakdown-part-label">イベント：2部</span>
                                    @if (reportForm.evaluationPart2.title) {
                                      <div class="breakdown-row first">
                                        <span class="sub-label">タイトル</span>
                                        {{ reportForm.evaluationPart2.title }}
                                      </div>
                                    }

                                    @if (reportForm.evaluationPart2.score) {
                                      <div class="breakdown-row">
                                        <span class="sub-label">点数</span>
                                        {{ getPlanMasterName('report_event_score', reportForm.evaluationPart2.score) }}
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        }

                        @if (!isLimitedDisplay && showUnderstanding) {
                          @if(reportForm.understandingScore){
                            <div class="form-row preview-row one-row">
                              <div class="form-label">参加者 理解度</div>
                              <div class="form-field">
                                {{ getPlanMasterName('report_understanding_score', reportForm.understandingScore) }}
                              </div>
                            </div>
                          }
                        }
                        @if (!isLimitedDisplay && showEvaluation) {
                          @if(reportForm.participantOpinions){
                            <div class="form-row preview-row">
                              <div class="form-label text">参加者による<br>意見/感想など</div>
                              <div class="form-field text">
                                <div class="text-content">{{ reportForm.participantOpinions }}</div>
                              </div>
                            </div>
                          }
                          @if (attachments.eval.length > 0) {
                            <div class="form-row preview-row">
                              <div class="form-label">評価データ</div>
                              <div class="form-field">
                                <div class="attachment-list">
                                  @for (att of attachments.eval; track $index; let i = $index) {
                                    <div class="attachment-item">
                                      <div class="attachment-name" [class.attachment-link]="att.downloadUrl"
                                            (click)="onDownloadPlanAttachment(att)">{{ att.fileName }}</div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                          @if (reportForm.selfEvalScore || reportForm.selfEvalComment) {
                            <div class="form-row preview-row">
                              <div class="form-label">自己評価/採点</div>
                              <div class="form-field comment">

                                @if (reportForm.selfEvalScore) {
                                  {{ getPlanMasterName('report_self_eval_score', reportForm.selfEvalScore) }}
                                }

                                @if (reportForm.selfEvalComment) {
                                  <div
                                    class="text-content comment-selfEvalScore"
                                  >{{ reportForm.selfEvalComment }}
                                  </div>
                                }

                              </div>
                            </div>
                          }

                          @if(reportForm.canRedo){
                            <div class="form-row preview-row one-row">
                              <div class="form-label">再実施の可否</div>
                              <div class="form-field">
                                {{ getPlanMasterName('report_can_redo', reportForm.canRedo) }}
                              </div>
                            </div>
                          }
                        }

                        @if (!isLimitedDisplay && showImages) {
                          @if (attachments.image.length > 0) {
                            <div class="form-row preview-row">
                              <div class="form-label">画像</div>
                              <div class="form-field image">
                                <div class="image-preview-grid">
                                  @for (att of attachments.image; track $index; let i = $index) {
                                    <div class="image-preview-item">
                                      @if (att.downloadUrl) {
                                        <img [src]="att.downloadUrl" [alt]="att.fileName" class="image-preview-img"
                                             (click)="openLightbox(att.downloadUrl)">
                                      } @else {
                                        <div class="image-preview-placeholder">{{ att.fileName }}</div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                          @if (lightboxUrl) {
                            <div class="lightbox-overlay" (click)="closeLightbox()">
                              <img [src]="lightboxUrl" class="lightbox-img" (click)="$event.stopPropagation()">
                            </div>
                          }
                        }

                        @if (!isLimitedDisplay) {
                          @if (attachments.deliverable.length > 0) {
                          <div class="form-row preview-row">
                            <div class="form-label">成果物データ</div>
                            <div class="form-field">
                              <div class="attachment-list">
                                @for (att of attachments.deliverable; track $index; let i = $index) {
                                  <div class="attachment-item">
                                    <div
                                      class="attachment-name"
                                      [class.attachment-link]="att.downloadUrl"
                                      (click)="onDownloadPlanAttachment(att)"
                                    >{{ att.fileName }}</div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          }
                        }

                        @if (attachments.reportDoc.length > 0) {
                          <div class="form-row preview-row">
                            <div class="form-label">報告書資料</div>
                            <div class="form-field">
                              <div class="attachment-list">
                                @for (att of attachments.reportDoc; track $index; let i = $index) {
                                  <div class="attachment-item">
                                    <div
                                      class="attachment-name"
                                      [class.attachment-link]="att.downloadUrl"
                                      (click)="onDownloadPlanAttachment(att)"
                                    >{{ att.fileName }}</div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          }

                        @if (!isLimitedDisplay) {
                          <div class="form-row preview-row">
                            <div class="form-label">組合員向け報告方法</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (getPlanMasterNameArray(reportForm.unionReportMethod, 'report_union_method'); as unionReportMethods) {
                                  @if (unionReportMethods.length > 0) {
                                    <div class="checkbox-grid">
                                      @for (unionReportMethod of unionReportMethods; track unionReportMethod; let i = $index) {
                                        <label class="priority-checkbox">
                                          <span class="priority-num">{{ i + 1 }}</span> {{ unionReportMethod }}
                                        </label>
                                      }
                                    </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }

                        @if (reportForm.memo) {
                          <div class="form-row preview-row">
                            <div class="form-label text">メモ</div>
                            <div class="form-field text">
                              <div class="text-content">{{ reportForm.memo }}</div>
                            </div>
                          </div>
                        }
                      }
                  </div>
                </div>
                }
              }
            }
            @if (activePreviewTab === 'other') {
              @if (activeDocumentTab === 'plan') {
                @if (!planPreviewReady) {
                  <div class="spinner">
                    <mat-spinner diameter="60"></mat-spinner>
                  </div>
                } @else if (planForm.categoryId === 8 || planForm.categoryId === 9) {
                  <div class="no-preview">
                    他組織に公開されません。
                  </div>
                } @else {
                  <div class="plan-preview-wrap">
                    <div class="form-table">

                      <div class="form-row preview-row">
                          <div class="form-label">タイトル</div>
                            <div class="form-field title">
                              @if (planForm.title) {
                                  {{ planForm.title }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                      </div>

                      <div class="form-row preview-row">
                        <div class="form-label">カテゴリー</div>
                          <div class="form-field">
                            @if (categoryMajorName) {
                              <div class="category-row large">
                                <span class="sub-label">大分類</span>
                                <span class="category-major-text">{{ categoryMajorName }}</span>
                              </div>
                            }
                            @if (!isInitialState) {
                              @if (getPlanMasterNameArray(planForm.categorySub, 'category_sub'); as subs) {
                                <div class="category-row">
                                  <span class="sub-label">中分類</span>
                                @if (subs.length > 0) {
                                        <div class="checkbox-grid">
                                            @for (sub of subs; track sub; let i = $index) {
                                              <label class="priority-checkbox">
                                                <span class="priority-num">{{ i + 1 }}</span> {{ sub }}
                                              </label>
                                            }
                                        </div>
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                              }
                            }
                          </div>
                      </div>
                      @if (!isInitialState) {
                        <div class="form-row preview-row one-row">
                          <div class="form-label">公開範囲</div>
                          <div class="form-field">
                            @if (planForm.publicScope) {
                              {{ getPlanMasterName('public_scope', planForm.publicScope) }}
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                        </div>
                        @if (planShowIssueSection) {
                          <div class="form-row preview-row">
                            <div class="form-label">改善したい指標</div>
                            <div class="form-field">
                              <div class="category-row">
                                <span class="sub-label">状態の変化</span>
                                @if (getPlanMasterNameArray(planForm.improvementIndicatorState, 'improvement_indicator_state'); as improvement_indicator_states) {
                                  @if (improvement_indicator_states.length > 0) {
                                          <div class="checkbox-grid">
                                              @for (improvement_indicator_state of improvement_indicator_states; track improvement_indicator_state; let i = $index) {
                                                <label class="priority-checkbox">
                                                  <span class="priority-num">{{ i + 1 }}</span> {{ improvement_indicator_state }}
                                                </label>
                                              }
                                          </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                            </div>
                            @if (planShowTargetOrg) {
                              <div class="category-row">
                                <span class="sub-label">企画の成果</span>
                                @if (planForm.improvementIndicatorOutcome) {
                                 {{ getPlanMasterName('improvement_indicator_outcome', planForm.improvementIndicatorOutcome) }}
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            }
                          </div>
                          </div>

                          <div class="form-row preview-row">
                            <div class="form-label">目的</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (getPlanMasterNameArray(planForm.purpose, 'purpose'); as purposes) {
                                  @if (purposes.length > 0) {
                                          <div class="checkbox-grid">
                                              @for (purpose of purposes; track purpose; let i = $index) {
                                                <label class="priority-checkbox">
                                                  <span class="priority-num">{{ i + 1 }}</span> {{ purpose }}
                                                </label>
                                              }
                                          </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }

                        <div class="form-row preview-row">
                          @if (planForm.summary) {
                            <div class="form-label text">企画の概要</div>
                            <div class="form-field text">
                              <div class="text-content">{{ planForm.summary }}</div>
                            </div>
                          } @else {
                            <div class="form-label">企画の概要</div>
                            <div class="form-field">
                              <span class="unregistered">未登録</span>
                            </div>
                          }
                        </div>

                        @if (planShowSocialTheme) {
                          <div class="form-row preview-row">
                            <div class="form-label">社会テーマ</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (getPlanMasterNameArray(planForm.socialTheme, 'social_theme'); as socials) {
                                  @if (socials.length > 0) {
                                          <div class="checkbox-grid">
                                              @for (social of socials; track social; let i = $index) {
                                                <label class="priority-checkbox">
                                                  <span class="priority-num">{{ i + 1 }}</span> {{ social }}
                                                </label>
                                              }
                                          </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }

                        <div class="form-row preview-row">
                          <div class="form-label">開催者所属</div>
                          <div class="form-field">
                            <div class="category-row">
                              <div class="checkbox-grid">
                                <span class="sub-label">組織</span>
                                @if (planForm.organizerUnit) {
                                  {{ getPlanMasterName('organizer_org_unit', planForm.organizerUnit) }}
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                            </div>
                          </div>
                        </div>

                        @if (planShowTargetOrg) {
                          <div class="form-row preview-row">
                            <div class="form-label">対象組織</div>
                            <div class="form-field">
                              <div class="category-row">
                                <div class="checkbox-grid">
                                  <span class="sub-label">単位</span>
                                    @if (planForm.targetUnit) {
                                     {{ getPlanMasterName('organizer_org_unit', planForm.targetUnit) }}
                                    } @else {
                                      <span class="unregistered">未登録</span>
                                    }
                                </div>
                              </div>
                            </div>
                          </div>
                        }

                        @if (planShowTargetOrg) {
                          <div class="form-row preview-row">
                            <div class="form-label">対象/参加者</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (planForm.participantCategory) {
                                  {{ getPlanMasterName('participant_category', planForm.participantCategory) }}
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              </div>
                              @if (planForm.participantCategory !== 199) {
                                <div class="category-row detail-row">

                                  <span class="sub-label">詳細</span>

                                  @if (getPlanParticipantDetailDisplay(); as detail) {
                                    <div class="detail-values">
                                      @for (item of detail.split('、'); track item; let last = $last) {
                                        <span class="detail-chip">
                                          {{ item }}@if (!last) {、}
                                        </span>
                                      }
                                    </div>

                                  } @else {
                                    <span class="unregistered">未登録</span>

                                  }

                                </div>
                              }
                            </div>
                          </div>

                          @if (getPlanAttrGenerationDisplay() || getPlanAttrGenderDisplay()) {
                            <div class="form-row preview-row">
                              <div class="form-label">└ 属性</div>

                              <div class="form-field">

                                @if (getPlanAttrGenerationDisplay(); as gen) {
                                  <div class="category-row">
                                    <div class="checkbox-grid">
                                      <span class="sub-label">年代</span>
                                      {{ gen }}
                                    </div>
                                  </div>
                                }

                                @if (getPlanAttrGenderDisplay(); as gender) {
                                  <div class="category-row">
                                    <div class="checkbox-grid">
                                      <span class="sub-label">性別</span>
                                      {{ gender }}
                                    </div>
                                  </div>
                                }

                              </div>
                            </div>
                          }
                        }

                        @if (
                          planshowCompanyOtherCollaboration &&
                          (
                            planCategoryId !== 10 ||
                            getPlanCompanyOtherCollaborationLabel()
                          )
                        ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">他労組共同開催</div>
                            <div class="form-field">
                              @if (getPlanCompanyOtherCollaborationLabel()) {
                                {{ getPlanCompanyOtherCollaborationLabel() }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (
                          planShowCompanyCollaboration &&
                          (
                            planCategoryId !== 10 ||
                            getPlanCompanyCollaborationLabel()
                          )
                          ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">会社協働・協賛</div>
                            <div class="form-field">
                              @if (getPlanCompanyCollaborationLabel()) {
                                {{ getPlanCompanyCollaborationLabel() }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }


                        <div class="form-row preview-row one-row">
                          <div class="form-label">実施方法</div>
                          <div class="form-field">
                            @if (planForm.implementationMethod) {
                              {{ getPlanMasterName('implementation_method', planForm.implementationMethod)}}
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                        </div>

                        @if (
                          planShowHoldingMethod &&
                          (
                            planCategoryId !== 10 ||
                            planForm.holdingMethod
                          )
                          ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">開催方法</div>
                            <div class="form-field">
                              @if (planForm.holdingMethod) {
                                {{ getPlanMasterName('holding_method', planForm.holdingMethod) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (
                          planShowEducationFormat &&
                        (
                          planCategoryId !== 10 ||
                          getPlanMultiDisplay(planForm.educationFormat, 'education_format')
                        )
                        ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">教育形式</div>
                            <div class="form-field">
                              @if (getPlanMultiDisplay(planForm.educationFormat, 'education_format')) {
                                {{ getPlanMultiDisplay(planForm.educationFormat, 'education_format') }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowSurveyMethod &&
                          (
                            planCategoryId !== 10 ||
                            planForm.surveyMethod
                          )
                          ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">調査方法</div>
                            <div class="form-field">
                              @if (planForm.surveyMethod) {
                                  {{ getPlanMasterName('survey_method', planForm.surveyMethod) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowAnnouncementMethod) {
                          <div class="form-row preview-row">
                            <div class="form-label">案内方法</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (getPlanMasterNameArray(planForm.announcementMethod, 'announcement_method'); as announces) {
                                  @if (announces.length > 0) {
                                          <div class="checkbox-grid">
                                              @for (announce of announces; track announce; let i = $index) {
                                                <label class="priority-checkbox">
                                                  <span class="priority-num">{{ i + 1 }}</span> {{ announce }}
                                                </label>
                                              }
                                          </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }

                        @if (planShowRecruitmentMethod) {
                          <div class="form-row preview-row">
                            <div class="form-label">応募方法</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (getPlanMasterNameArray(planForm.recruitmentMethod, 'recruitment_method'); as recruits) {
                                  @if (recruits.length > 0) {
                                    <div class="checkbox-grid">
                                        @for (recruit of recruits; track recruit; let i = $index) {
                                          <label class="priority-checkbox">
                                            <span class="priority-num">{{ i + 1 }}</span> {{ recruit }}
                                          </label>
                                        }
                                    </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }

                        @if (planShowVenue) {
                          <div class="form-row preview-row">
                            <div class="form-label">会場</div>
                            <div class="form-field">{{ getPlanMasterName('venue', planForm.venue) }}</div>
                          </div>
                        }

                        <div class="form-row preview-row">
                          <div class="form-label">
                            開催日数
                          </div>

                          <div class="form-field">
                            @for (row of planScheduleRows; track row.index) {
                              <div class="category-row">

                                @if (getPlanScheduleDisplay(row.index); as schedule) {
                                <span
                                  class="schedule-label"
                                  [class.period]="planForm.numberOfDays === 'period'"
                                >
                                  {{ row.label }}
                                </span>

                                  @if (schedule.date && schedule.start && schedule.end) {
                                    <span class="date-label">
                                      {{ schedule.date }}
                                    </span>

                                    <span class="time-group">
                                      <span class="time-label">開始</span>
                                      <span>{{ schedule.start }}</span>
                                    </span>

                                    <span class="time-group">
                                      <span class="time-label">終了</span>
                                      @if (schedule.end  && schedule.start <= schedule.end) {
                                        <span>{{ schedule.end }}</span>
                                      } @else {
                                        <span class="unregistered">未登録</span>
                                      }
                                    </span>

                                    <span class="time-group">
                                      <span class="time-label">実施時間</span>

                                      @if (schedule.duration) {
                                        <span>{{ schedule.duration }}</span>
                                      }
                                    </span>

                                  } @else {
                                    <span class="unregistered">未登録</span>

                                  }

                                }

                              </div>
                            }
                          </div>
                        </div>


                        @if (planShowEstimatedParticipants) {
                          <div class="form-row preview-row">
                            <div class="form-label">想定参加人数</div>
                            <div class="form-field">
                              @if (planForm.estimatedParticipants !== null && planForm.estimatedParticipants !== undefined) {
                                <div class="number-with-unit">
                                  {{ planForm.estimatedParticipants }}
                                  <span class="unit">人</span>
                                  @if (coverageRate) {
                                    <span class="calc-result">カバー率　{{ coverageRate }}</span>
                                  }
                                </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowCostSection && ( planForm.categoryId != 10 || planForm.estimatedTotalCost )) {
                          <div class="form-row preview-row">
                            <div class="form-label">想定費用総額</div>
                            <div class="form-field">
                              @if (planForm.estimatedTotalCost !== null && planForm.estimatedTotalCost !== undefined) {
                                <div class="number-with-unit">
                                  {{ formatPlanCurrency(planForm.estimatedTotalCost) }}
                                  <span class="unit">円</span>
                                  @if (costPerPerson) {
                                    <span class="calc-result">一人当たり費用　{{ costPerPerson }}</span>
                                  }
                                </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowSubsidyAndVendors && ( planForm.categoryId !== 10 || planForm.subsidyAmount )) {
                          <div class="form-row preview-row">
                            <div class="form-label">補助金額</div>
                            <div class="form-field">
                              @if (planForm.subsidyAmount !== null && planForm.subsidyAmount !== undefined) {
                                <div class="number-with-unit">
                                  {{ formatPlanCurrency(planForm.subsidyAmount) }}
                                  <span class="unit">円</span>
                                  @if (subsidyRate) {
                                    <span class="calc-result">補助率　{{ subsidyRate }}</span>
                                  }
                                </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowSubsidyAndVendors && visibleVendors.length > 0) {
                          @for (vendor of visibleVendors; track $index; let i = $index) {
                          <div class="vendor-section" [class.has-divider]="i > 0" [class.is-last]="visibleVendors.length > 1 && i === visibleVendors.length - 1">
                            <div class="form-row preview-row">

                              <div class="form-label" [class.vendor]="true">
                                外部業者
                              </div>

                              <div class="form-field vendor">
                                <div class="vendor-fields">

                                  @if (vendor.companyName) {
                                    <div class="vendor-row">
                                      <span class="sub-label">会社/組織名</span>
                                      <div class="field-with-count">
                                        {{ vendor.companyName }}
                                      </div>
                                    </div>
                                  }

                                  @if (vendor.workSummary) {
                                    <div class="vendor-row">
                                      <span class="sub-label">担当概要</span>
                                      <div class="field-with-count text">
                                        <div class="text-content">{{ vendor.workSummary }}</div>
                                      </div>
                                    </div>
                                  }

                                  @if (vendor.workDurationMinutes != null) {
                                    <div class="vendor-row">
                                      <span class="sub-label">担当時間</span>
                                      <div class="field-with-count">
                                        {{ formatPlanDuration(vendor.workDurationMinutes) }}
                                      </div>
                                    </div>
                                  }

                                  @if (vendor.specificCost != null) {
                                    <div class="vendor-row">
                                      <span class="sub-label">金額</span>
                                      <div class="number-with-unit vendor-margintop">
                                        @if (getVendorCostLabel(vendor.specificCost); as label) {
                                          <span>
                                            概算費用　{{ label }}
                                          </span>
                                        }
                                      </div>
                                    </div>
                                  }

                                </div>
                              </div>
                            </div>
                          </div>
                          }
                        }

                        @if (planForm.implementationChallenges) {
                          <div class="form-row preview-row">
                            <div class="form-label text">実施する際の課題</div>
                            <div class="form-field text">
                              <div class="text-content">{{ planForm.implementationChallenges }}</div>
                            </div>
                          </div>
                        }

                        @if (planForm.countermeasures) {
                          <div class="form-row preview-row">
                            <div class="form-label text">対策</div>
                            <div class="form-field text">
                              <div class="text-content">{{ planForm.countermeasures }}</div>
                            </div>
                          </div>
                        }

                        @if (planShowWorkplaceSection) {
                          <div class="form-row preview-row">
                              @if (planForm.workplaceExpectedIssues) {
                                <div class="form-label text">該当職場の想定議題</div>
                                <div class="form-field text">
                                  <div class="text-content">{{ planForm.workplaceExpectedIssues }}</div>
                                </div>
                              } @else {
                                <div class="form-label">該当職場の想定議題</div>
                                <div class="form-field">
                                  <span class="unregistered">未登録</span>
                                </div>
                              }
                          </div>
                        }

                        @if (planShowWorkplaceSection) {
                          <div class="form-row preview-row">
                              @if (planForm.keyHearingItems) {
                                <div class="form-label text">重点ヒアリング項目</div>
                                <div class="form-field text">
                                  <div class="text-content">{{ planForm.keyHearingItems }}</div>
                                </div>
                              } @else {
                                <div class="form-label">重点ヒアリング項目</div>
                                <div class="form-field">
                                  <span class="unregistered">未登録</span>
                                </div>
                              }
                          </div>
                        }

                        @if (planShowEffectiveness &&
                          (
                            planCategoryId !== 10 ||
                            planForm.effectivenessMeasurement
                          )
                          ) {
                          <div class="form-row preview-row">
                            <div class="form-label">効果測定</div>
                            <div class="form-field">
                              @if (planForm.effectivenessMeasurement) {
                                {{ getPlanMasterName('effectiveness_measurement', planForm.effectivenessMeasurement) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }

                        @if (planShowMeetingSection) {
                          <div class="form-row preview-row">
                            <div class="form-label">会議体・対応形式</div>
                            <div class="form-field">
                              @if (getPlanMultiDisplay(planForm.meetingFormats, 'meeting_format')) {
                                {{ getPlanMultiDisplay(planForm.meetingFormats, 'meeting_format') }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                          <div class="form-row preview-row">
                            <div class="form-label">主な相手区分</div>
                            <div class="form-field">
                              @if (getPlanMultiDisplay(planForm.counterpartTypes, 'counterpart_type')) {
                                {{ getPlanMultiDisplay(planForm.counterpartTypes, 'counterpart_type') }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }
                      }

                    </div>
                  </div>

                }
              } @else if (activeDocumentTab === 'report') {
                @if (!planPreviewReady) {
                  <div class="spinner">
                    <mat-spinner diameter="60"></mat-spinner>
                  </div>
                } @else if (reportForm.categoryId === 8 || reportForm.categoryId === 9) {
                  <div class="no-preview">
                    他組織に公開されません。
                  </div>
                } @else {
                  <div class="plan-preview-wrap">
                    <div class="form-table">
                    <div class="form-row preview-row">
                      <div class="form-label">タイトル</div>
                        <div class="form-field title">
                          @if (planForm.title) {
                              {{ planForm.title }}
                          } @else {
                            <span class="unregistered">未登録</span>
                          }
                        </div>
                    </div>

                    <div class="form-row preview-row">
                      <div class="form-label">カテゴリー</div>
                        <div class="form-field">
                          @if (categoryMajorName) {
                            <div class="category-row large">
                              <span class="sub-label">大分類</span>
                              <span class="category-major-text">{{ categoryMajorName }}</span>
                            </div>
                          }
                            @if (getPlanMasterNameArray(planForm.categorySub, 'category_sub'); as subs) {
                              <div class="category-row">
                                <span class="sub-label">中分類</span>
                              @if (subs.length > 0) {
                                      <div class="checkbox-grid">
                                          @for (sub of subs; track sub; let i = $index) {
                                            <label class="priority-checkbox">
                                              <span class="priority-num">{{ i + 1 }}</span> {{ sub }}
                                            </label>
                                          }
                                      </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                            }
                        </div>
                    </div>
                    @if (!isInitialStateReport) {
                      <div class="form-row preview-row one-row">
                        <div class="form-label">実施状況</div>
                        <div class="form-field implementation">
                          @if (reportForm.implementationStatus) {
                            {{ getPlanMasterName('report_implementation_status', reportForm.implementationStatus)}}
                          } @else {
                            <span class="unregistered">未登録</span>
                          }
                        </div>
                      </div>

                      @if (!isLimitedDisplay) {
                        <div class="form-row preview-row one-row">
                          <div class="form-label">実施方法</div>
                          <div class="form-field">
                            @if (reportForm.implementationMethod) {
                              {{ getPlanMasterName('implementation_method', reportForm.implementationMethod)}}
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                          </div>
                        </div>
                      }

                      @if (showProblem) {
                        <div class="form-row preview-row">
                          <div class="form-label">問題の有無</div>
                          <div class="form-field comment">
                            @if (getReportHasProblemabel()) {
                              {{ getReportHasProblemabel() }}
                            } @else {
                              <span class="unregistered">未登録</span>
                            }
                            @if( reportForm.problemComment ){
                              <div class="text-content comment">{{ reportForm.problemComment }}</div>
                            }
                          </div>
                        </div>
                      }

                      <div class="form-row preview-row">
                        <div class="form-label">企画書からの変更点</div>
                        <div class="form-field comment">
                          @if (getReportHasChangeFromPlan()) {
                            {{ getReportHasChangeFromPlan() }}
                          } @else {
                            <span class="unregistered">未登録</span>
                          }
                          @if( reportForm.changeFromPlanComment ){
                            <div class="text-content comment">{{ reportForm.changeFromPlanComment }}</div>
                          }
                        </div>
                      </div>

                      @if (!isLimitedDisplay && showCost) {
                          @if (
                            reportForm.categoryId !== 10 ||
                            (reportForm.actualTotalCost !== null && reportForm.actualTotalCost !== undefined)
                          ) {
                          <div class="form-row preview-row">
                            <div class="form-label">実費費用総額</div>
                            <div class="form-field">
                              @if (reportForm.actualTotalCost !== null && reportForm.actualTotalCost !== undefined) {
                                <div class="number-with-unit">
                                  {{ formatPlanCurrency(reportForm.actualTotalCost) }}
                                  <span class="unit">円</span>
                                  @if (costDiff) {
                                    <span class="calc-result">想定費用との差額　{{ costDiff }}</span>
                                  }
                                </div>
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }
                        @if(reportForm.costDiffReason){
                          <div class="form-row preview-row">
                            <div class="form-label text">差額発生理由など</div>
                            <div class="form-field text">
                              <div class="field-with-count">
                                <div class="text-content">{{ reportForm.costDiffReason }}</div>
                              </div>
                            </div>
                          </div>
                        }
                      }

                      @if (!isLimitedDisplay && showTotalParticipants) {
                        <div class="form-row preview-row one-row">
                          <div class="form-label">参加者</div>
                          <div class="form-field">
                            <div class="category-row">
                              <span class="time-group">
                                <span class="sub-label first-inline">総数</span>
                                <div class="number-with-unit">
                                  @if (reportForm.participantTotal !== null && reportForm.participantTotal !== undefined) {
                                    {{ reportForm.participantTotal }}
                                    <span class="unit">人</span>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                </div>
                              </span>
                              @if (showParticipantDetail) {
                                <span class="time-group">
                                  <span class="sub-label ml20">新規</span>
                                  <div class="number-with-unit">
                                    @if (reportForm.participantNew !== null && reportForm.participantNew !== undefined) {
                                      {{ reportForm.participantNew }}
                                      <span class="unit">人</span>
                                    } @else {
                                      <span class="unregistered">未登録</span>
                                    }
                                  </div>
                                </span>
                              }
                            </div>
                          </div>
                        </div>

                        @if (showParticipantDetail) {
                          @if (
                            reportForm.ageRatio?.unknown ||
                            reportForm.ageRatio?.under19 != null ||
                            reportForm.ageRatio?.age20s != null ||
                            reportForm.ageRatio?.age30s != null ||
                            reportForm.ageRatio?.age40s != null ||
                            reportForm.ageRatio?.age50s != null ||
                            reportForm.ageRatio?.over60 != null
                          ) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">年代</div>
                            <div class="form-field">
                              <div class="category-row age">
                                @if(reportForm.ageRatio.unknown) {
                                  不明
                                } @else {
                                  @if( reportForm.ageRatio.under19 ){
                                    <span class="time-group">
                                      <span class="sub-label">19歳以下</span>
                                        {{ reportForm.ageRatio.under19 }}%
                                    </span>
                                  }
                                  @if( reportForm.ageRatio.age20s ){
                                    <span class="time-group">
                                      <span class="sub-label">20代</span>
                                        {{ reportForm.ageRatio.age20s }}%
                                    </span>
                                  }
                                  @if( reportForm.ageRatio.age30s ){
                                    <span class="time-group">
                                      <span class="sub-label">30代</span>
                                        {{ reportForm.ageRatio.age30s }}%
                                    </span>
                                  }
                                  @if( reportForm.ageRatio.age40s ){
                                    <span class="time-group">
                                      <span class="sub-label">40代</span>
                                        {{ reportForm.ageRatio.age40s }}%
                                    </span>
                                  }
                                  @if( reportForm.ageRatio.age50s ){
                                    <span class="time-group">
                                      <span class="sub-label">50代</span>
                                        {{ reportForm.ageRatio.age50s }}%
                                    </span>
                                  }
                                  @if( reportForm.ageRatio.over60 ){
                                    <span class="time-group">
                                      <span class="sub-label">60代以上</span>
                                        {{ reportForm.ageRatio.over60 }}%
                                    </span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                          }
                          <div class="form-row preview-row one-row">
                            <div class="form-label">女性比率</div>
                            <div class="form-field">
                              @if (reportForm.femaleRatio) {
                                {{ getPlanMasterName('report_female_ratio', reportForm.femaleRatio) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                        }
                      }

                      @if (!isLimitedDisplay && showOrgActivity) {
                        <div class="form-row preview-row">
                          @if (reportForm.implementationContent) {
                            <div class="form-label text">実施内容</div>
                            <div class="form-field text">
                              <div class="text-content">{{ reportForm.implementationContent }}</div>
                            </div>
                          } @else {
                            <div class="form-label">実施内容</div>
                            <div class="form-field">
                              <span class="unregistered">未登録</span>
                            </div>
                          }
                        </div>
                      }
                    }

                    @if (!isLimitedDisplay && showOutcomeResult) {
                      <div class="form-row preview-row one-row">
                        <div class="form-label">改善したい指標</div>
                        <div class="form-field">
                          <div class="category-row">
                            <span class="sub-label">企画の成果</span>
                            <div class="checkbox-grid">
                              @if (reportForm.improvementOutcomeText) {
                                {{ reportForm.improvementOutcomeText }}
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      @if (!isInitialStateReport) {
                        <div class="form-row preview-row">
                          @if (reportForm.implementationResult) {
                            <div class="form-label text">実施結果/成果</div>
                            <div class="form-field text">
                              <div class="text-content">{{ reportForm.implementationResult }}</div>
                            </div>
                          } @else {
                            <div class="form-label">実施結果/成果</div>
                            <div class="form-field">
                              <span class="unregistered">未登録</span>
                            </div>
                          }
                        </div>
                      }
                    }

                      @if (!isInitialStateReport) {
                        @if (!isLimitedDisplay && showStakeholderAndChallenges) {
                          @if( reportForm.challengesNotes ){
                            <div class="form-row preview-row">
                              <div class="form-label text">課題/気づき</div>
                              <div class="form-field text">
                                <div class="field-with-count">
                                  <div class="text-content">{{ reportForm.challengesNotes }}</div>
                                </div>
                              </div>
                            </div>
                          }
                        }

                        @if (!isLimitedDisplay && showNextImprovement) {
                          <div class="form-row preview-row">
                          @if (reportForm.nextImprovement) {
                            <div class="form-label text">次回改善点/引継事項</div>
                            <div class="form-field text">
                              <div class="field-with-count">
                                <div class="text-content">{{ reportForm.nextImprovement }}</div>
                              </div>
                            </div>
                          } @else {
                            <div class="form-label">次回改善点/引継事項</div>
                            <div class="form-field">
                              <span class="unregistered">未登録</span>
                            </div>
                          }
                          </div>
                        }

                        @if (!isLimitedDisplay && showLaborNegotiation) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">協議状況</div>
                            <div class="form-field negotiation">
                              @if (reportForm.negotiationStatus) {
                                {{ getPlanMasterName('report_negotiation_status', reportForm.negotiationStatus) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>


                          @if (showAgreementContent) {
                            <div class="form-row preview-row">
                              @if (reportForm.agreementContent) {
                                <div class="form-label text">合意内容</div>
                                <div class="form-field text">
                                  <div class="field-with-count">
                                    <div class="text-content">{{ reportForm.agreementContent }}</div>
                                  </div>
                                </div>
                              } @else {
                                <div class="form-label">合意内容</div>
                                <div class="form-field">
                                  <span class="unregistered">未登録</span>
                                </div>
                              }
                              </div>
                          }

                          <div class="form-row preview-row">
                            @if (reportForm.companyClaim) {
                              <div class="form-label text">会社側 主張/論理</div>
                              <div class="form-field text">
                                <div class="field-with-count">
                                  <div class="text-content">{{ reportForm.companyClaim }}</div>
                                </div>
                              </div>
                            } @else {
                              <div class="form-label">会社側 主張/論理</div>
                              <div class="form-field">
                                <span class="unregistered">未登録</span>
                              </div>
                            }
                          </div>

                          <div class="form-row preview-row">
                            @if (reportForm.unionClaim) {
                              <div class="form-label text">労組側 主張/論理</div>
                              <div class="form-field text">
                                <div class="field-with-count">
                                  <div class="text-content">{{ reportForm.unionClaim }}</div>
                                </div>
                              </div>
                            } @else {
                              <div class="form-label">労組側 主張/論理</div>
                              <div class="form-field">
                                <span class="unregistered">未登録</span>
                              </div>
                            }
                          </div>

                          @if (reportForm.unresolvedPoints) {
                            <div class="form-row preview-row">
                                <div class="form-label text">未整理論点/積み残し</div>
                                <div class="form-field text">
                                  <div class="field-with-count">
                                    <div class="text-content">{{ reportForm.unresolvedPoints }}</div>
                                  </div>
                                </div>
                            </div>
                          }
                        }
                      }


                      @if (!isLimitedDisplay && showImprovementResult) {
                        <div class="form-row preview-row one-row">
                          <div class="form-label">改善したい指標</div>
                          <div class="form-field">
                            <div class="category-row">
                              <span class="sub-label">状態の変化</span>
                              @if (getPlanMasterNameArray(_rawImprovementState, 'improvement_indicator_state'); as improvement_indicator_states) {
                                @if (improvement_indicator_states.length > 0) {
                                        <div class="checkbox-grid">
                                            @for (improvement_indicator_state of improvement_indicator_states; track improvement_indicator_state; let i = $index) {
                                              <label class="priority-checkbox">
                                                <span class="priority-num">{{ i + 1 }}</span> {{ improvement_indicator_state }}
                                              </label>
                                            }
                                        </div>
                                } @else {
                                  <span class="unregistered">未登録</span>
                                }
                              }
                            </div>
                          </div>
                        </div>
                        @if (!isInitialStateReport) {
                          <div class="form-row preview-row one-row">
                            <div class="form-label">改善指標に対する結果</div>
                            <div class="form-field negotiation">
                              @if (reportForm.improvementResultRating) {
                                {{ getPlanMasterName('report_improvement_result', reportForm.improvementResultRating) }}
                              } @else {
                                <span class="unregistered">未登録</span>
                              }
                            </div>
                          </div>
                          @if (reportForm.improvementResultReason) {
                            <div class="form-row preview-row">
                              <div class="form-label text">判断理由/補足</div>
                              <div class="form-field text">
                                <div class="field-with-count">
                                  <div class="text-content">{{ reportForm.improvementResultReason }}</div>
                                </div>
                              </div>
                            </div>
                          }
                        }
                      }

                      @if (!isInitialStateReport) {
                        @if (!isLimitedDisplay && showEvaluation) {
                          @if (reportForm.reAttendanceRate != null) {
                            <div class="form-row preview-row">
                              <div class="form-label">再参加意向比率</div>
                              <div class="form-field">
                                <div class="number-with-unit">
                                  {{ reportForm.reAttendanceRate }}
                                  <span class="unit">%</span>
                                </div>
                              </div>
                            </div>
                          }

                          <div class="form-row preview-row">
                            <div class="form-label">参加者 評価</div>
                            <div class="form-field">
                              <div class="category-row">
                                <span class="time-group">
                                  @if (reportForm.participantEvalScore) {
                                    {{ getPlanMasterName('report_eval_score', reportForm.participantEvalScore) }}
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                </span>
                                @if (!isEvaluationUnrated) {
                                  <span class="time-group">
                                    <span class="sub-label ml20">評価収集数</span>
                                    @if (reportForm.evalCollectedCount !== null && reportForm.evalCollectedCount !== undefined) {
                                      {{ reportForm.evalCollectedCount }}
                                    } @else {
                                      <span class="unregistered">未登録</span>
                                    }
                                  </span>
                                  @if (c !== 6) {
                                    <span class="time-group">
                                      <span class="sub-label ml20">収集率</span>
                                      {{ collectionRate }}
                                    </span>
                                  }
                                }
                              </div>
                              <div class="category-row">
                                @if (isEvaluationUnrated) {
                                  <span class="sub-label">未評価理由</span>
                                    @if (reportForm.unevaluatedReason) {
                                      <div class="text-content unevaluatedReason">{{ reportForm.unevaluatedReason }}</div>
                                    } @else {
                                      <span class="unregistered">未登録</span>
                                    }
                              }
                              </div>
                            </div>
                          </div>

                          @if (
                            showParticipantDetail &&
                            (
                              reportForm.evaluationPart1.title ||
                              reportForm.evaluationPart1.score ||
                              reportForm.evaluationPart2.title ||
                              reportForm.evaluationPart2.score
                            )
                          ) {
                            <div class="form-row preview-row">
                              <div class="form-label">評価 内訳</div>
                              <div class="form-field eval">
                                <!-- イベント：1部 -->
                                @if (reportForm.evaluationPart1.title || reportForm.evaluationPart1.score) {
                                  <div class="eval-breakdown-block">
                                    <span class="breakdown-part-label">イベント：1部</span>
                                    @if (reportForm.evaluationPart1.title) {
                                      <div class="breakdown-row first">
                                        <span class="sub-label">タイトル</span>
                                        {{ reportForm.evaluationPart1.title }}
                                      </div>
                                    }

                                    @if (reportForm.evaluationPart1.score) {
                                      <div class="breakdown-row">
                                        <span class="sub-label">点数</span>
                                        {{ getPlanMasterName('report_event_score', reportForm.evaluationPart1.score) }}
                                      </div>
                                    }
                                  </div>
                                }

                                <!-- イベント：2部 -->
                                @if (reportForm.evaluationPart2.title || reportForm.evaluationPart2.score) {
                                  <div class="eval-breakdown-block">
                                    <span class="breakdown-part-label">イベント：2部</span>
                                    @if (reportForm.evaluationPart2.title) {
                                      <div class="breakdown-row first">
                                        <span class="sub-label">タイトル</span>
                                        {{ reportForm.evaluationPart2.title }}
                                      </div>
                                    }

                                    @if (reportForm.evaluationPart2.score) {
                                      <div class="breakdown-row">
                                        <span class="sub-label">点数</span>
                                        {{ getPlanMasterName('report_event_score', reportForm.evaluationPart2.score) }}
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        }

                        @if (!isLimitedDisplay && showUnderstanding) {
                          @if(reportForm.understandingScore){
                            <div class="form-row preview-row one-row">
                              <div class="form-label">参加者 理解度</div>
                              <div class="form-field">
                                {{ getPlanMasterName('report_understanding_score', reportForm.understandingScore) }}
                              </div>
                            </div>
                          }
                        }
                        @if (!isLimitedDisplay && showEvaluation) {
                          @if(reportForm.participantOpinions){
                            <div class="form-row preview-row">
                              <div class="form-label text">参加者による<br>意見/感想など</div>
                              <div class="form-field text">
                                <div class="text-content">{{ reportForm.participantOpinions }}</div>
                              </div>
                            </div>
                          }
                          @if (reportForm.selfEvalScore || reportForm.selfEvalComment) {
                            <div class="form-row preview-row">
                              <div class="form-label">自己評価/採点</div>
                              <div class="form-field comment">

                                @if (reportForm.selfEvalScore) {
                                  {{ getPlanMasterName('report_self_eval_score', reportForm.selfEvalScore) }}
                                }

                                @if (reportForm.selfEvalComment) {
                                  <div
                                    class="text-content comment-selfEvalScore"
                                  >{{ reportForm.selfEvalComment }}
                                  </div>
                                }

                              </div>
                            </div>
                          }

                          @if(reportForm.canRedo){
                            <div class="form-row preview-row one-row">
                              <div class="form-label">再実施の可否</div>
                              <div class="form-field">
                                {{ getPlanMasterName('report_can_redo', reportForm.canRedo) }}
                              </div>
                            </div>
                          }
                        }

                        @if (!isLimitedDisplay) {
                          <div class="form-row preview-row">
                            <div class="form-label">組合員向け報告方法</div>
                            <div class="form-field">
                              <div class="category-row">
                                @if (getPlanMasterNameArray(reportForm.unionReportMethod, 'report_union_method'); as unionReportMethods) {
                                  @if (unionReportMethods.length > 0) {
                                    <div class="checkbox-grid">
                                      @for (unionReportMethod of unionReportMethods; track unionReportMethod; let i = $index) {
                                        <label class="priority-checkbox">
                                          <span class="priority-num">{{ i + 1 }}</span> {{ unionReportMethod }}
                                        </label>
                                      }
                                    </div>
                                  } @else {
                                    <span class="unregistered">未登録</span>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  </div>
                }
              }
            }
          </div>

          <!-- 最終更新 -->
          @if (showLastUpdated) {
          <div class="last-updated">
            最終更新
            @if (activeDocumentTab === 'plan'){
            {{
              getFormattedDate(
                planForm.lastUpdatedAt || eventDetail?.draftedAccount.createdAt
              )
            }}
            &nbsp;&nbsp;

            {{
              planForm.lastUpdatedOfficialPositionName
                || eventDetail?.draftedAccount?.position
            }}

            {{
              planForm.lastUpdatedName
                || eventDetail?.draftedAccount?.name
            }}
          } @else{
            {{
              getFormattedDate(
                reportForm.lastUpdatedAt || eventDetail?.draftedAccount.createdAt
              )
            }}
            &nbsp;&nbsp;

            {{
              reportForm.lastUpdatedOfficialPositionName
                || eventDetail?.draftedAccount?.position
            }}

            {{
              reportForm.lastUpdatedName
                || eventDetail?.draftedAccount?.name
            }}
          }
          </div>
          }
        </div>

        <mat-divider></mat-divider>

        <!-- 管理用メモ -->
        <div class="memo-section">
          <div class="memo-section-header">
            <h3 class="section-title">管理用メモ（企画書・報告書 共通）</h3>
            <!-- TODO：ぐるぐる出すならmemoSaving使う -->
            @if (canUpdateMemo) {
              <button
                mat-raised-button
                class="update-btn"
                (click)="onUpdateMemo()"
              >
                更新
              </button>
            }
          </div>
          <div class="memo-wrapper">
            <textarea
              class="memo-textarea"
              [(ngModel)]="memoContent"
              placeholder="メモを入力"
              maxlength="10000"
            ></textarea>
          </div>
          <div class="last-updated">
            最終更新 {{ getFormattedDate(eventDetail.adminMemo.lastUpdatedAt) }}
            &nbsp;&nbsp;
            {{ eventDetail.adminMemo.lastUpdatedOfficialPositionName }}
            {{ eventDetail.adminMemo.lastUpdatedName }}
          </div>
        </div>

        <!-- 承認セクション -->
        <div class="approval-section">
          <h3 class="section-title">承認</h3>

          <!-- 承認依頼ボタン -->
          @if (
            eventDetail.canRequestApproval &&
            eventDetail.isDrafter &&
            !(
              eventDetail.documentType === 'report' &&
              activeDocumentTab === 'plan'
            )
          ) {
            <div
              class="approval-request-area"
              [class.no-flow]="!eventDetail.approvalFlows?.length"
            >
              <button
                mat-raised-button
                class="approval-request-btn"
                (click)="onOpenApprovalRequest()"
                [disabled]="isSubmittingApproval || hasRequiredFieldsMissing"
              >
                @if (isSubmittingApproval) {
                  <mat-spinner diameter="20"></mat-spinner>
                } @else {
                  <span>承認依頼</span>
                }
              </button>
              @if (hasRequiredFieldsMissing) {
                <div class="required-error">
                  必須項目が未入力です。
                </div>
              }
            </div>
          }

          <!-- 承認フロー -->
          @if (eventDetail.approvalFlows?.length) {
            @for (flow of eventDetail.approvalFlows; track flow.flowId) {
              <div
                class="approval-panel"
                [class.inactive-flow]="!flow.isActive"
              >

                @for (step of flow.steps; track step.level) {
                  <div class="approval-row">

                    <div class="approval-level">
                      {{ step.level === 0 ? '起票' : step.level + '次承認' }}
                    </div>

                    <div class="approval-users">

                      @for (approver of step.approvers; track approver.id) {
                        @if (getStatus(step, approver.id); as statusInfo) {
                          <div class="approval-user-row">

                            <div class="status-area">
                              @if (
                                statusInfo.status !== 'submitted' &&
                                statusInfo.status !== 'reviewing' &&
                                statusInfo.status !== 'skipped'
                              ) {
                                <div class="status-icon">
                                  <span
                                    [class.status-approved]="statusInfo.status === 'approved'"
                                    [class.status-returned]="statusInfo.status === 'returned'"
                                  >
                                    {{ getApprovalStatusLabel(statusInfo.status) }}
                                  </span>
                                </div>
                              }
                            </div>

                            <div class="user-name">
                              @if (approver.position) {
                                <span class="position">{{ approver.position }}</span>
                              }{{ approver.name }}
                            </div>

                            <div class="user-affiliation">
                              @if (eventDetail.status === 'completed' ) {
                                @if (approver.organizations_text?.length) {
                                  {{ approver.organizations_text[0] }}
                                  @if (approver.organizations_text.length > 1) {
                                    など
                                  }
                                }
                              } @else{
                                @if (approver.affiliations?.length) {
                                  {{ approver.affiliations[0] }}
                                  @if (approver.affiliations.length > 1) {
                                    など
                                  }
                                }
                              }
                            </div>

                            <div class="action-date">
                              @if (
                                statusInfo.date &&
                                statusInfo.status !== 'reviewing'
                              ) {
                                {{ getStatusInfoFormattedDate(statusInfo.date) }}
                              }
                            </div>

                          </div>

                        }

                      }

                    </div>

                  </div>

                  @if (!$last) {
                    <mat-divider></mat-divider>
                  }

                }

                @if (
                  flow.isActive &&
                  (currentStep?.canApprove || currentStep?.canReturn)
                ) {
                  <div class="approval-buttons">

                    @if (currentStep?.canReturn) {
                      <button
                        mat-raised-button
                        class="return-btn"
                        (click)="onReturn(currentStep)"
                      >
                        差戻し
                      </button>
                    }

                    @if (currentStep?.canApprove && currentStep?.level !== 9) {
                      <button
                        mat-raised-button
                        class="basicinfo"
                        (click)="onOpenApprovalRequest()"
                      >
                        次を選択して承認
                      </button>
                    }

                    @if (currentStep?.canApprove) {
                      <button
                        mat-raised-button
                        color="primary"
                        class="yes-btn"
                        (click)="onApprove(currentStep)"
                      >
                        決裁
                      </button>
                    }

                  </div>
                }

              </div>

            }

          }
        </div>
      }
    </div>
  </div>
}
